import { Fragment } from "react";
import { Timeline } from "@mui/lab";
import LoanInformation from "./LoanInformation";
import Typography from "@mui/material/Typography";
import color from "context/MaterialUITheme/color";
import QuestionsBox from "components/CQuestionChat";
import IdVerification from "./Steps/IdVerification";
import OfferInformation from "./Steps/OfferInformation";
import TitleVerification from "./Steps/TitleVerification";
import CreditVerification from "./Steps/CreditVerification";
import IncomeVerification from "./Steps/IncomeVerification";
import NPEAnnouncement from "./StepsDialogs/NPEAnnouncement";
import FundingVerification from "./Steps/FundingVerification";
import HomeValueVerification from "./Steps/HomeValueVerification";
import FinalOfferVerification from "./Steps/FinalOfferVerification";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import DemographicDataVerification from "./Steps/DemographicsVerification";
import ScheduleClosingVerification from "./Steps/ScheduleClosingVerification";
import InitialOfferVerification from "./StepsDialogs/InitialOfferVerification";
import InitialDisclosuresVerification from "./Steps/InitialDisclosuresVerification";
import ClosingDisclosuresVerification from "./Steps/ClosingDisclosuresVerification";
import AnnuncementCoborrowerPending from "./StepsDialogs/AnnuncementCoborrowerPending";
import AnnuncementCreateNewOfferPending from "./StepsDialogs/AnnuncementCreateNewOfferPending";

const CTracker: React.FC<{
  isBorrower: boolean;
}> = ({ isBorrower }) => {
  const theme = useTheme();

  return (
    <Fragment>
      <Container
        maxWidth="md"
        disableGutters={useMediaQuery(theme.breakpoints.only("xs"))}
      >
        <Box maxWidth="md">
          <Typography
            mt={4}
            mb={5}
            variant="h1"
            lineHeight={1}
            color={color.black}
            letterSpacing={-0.8}
            px={{ xs: 2, md: 0 }}
            fontSize={{ xs: "2.5rem", md: "4.2rem" }}
          >
            Track Your Loan Application
          </Typography>
          <Box
            px={{ xs: 2, md: 6 }}
            py={{ xs: 4, md: 5 }}
            bgcolor={color.white}
            sx={{
              scrollbarWidth: "none",
              borderTopLeftRadius: 33,
              borderTopRightRadius: 33,
            }}
          >
            <LoanInformation />
          </Box>
          <Box
            mt={0.5}
            px={{ xs: 0, md: 4 }}
            py={{ xs: 2, md: 3 }}
            bgcolor={color.white}
            sx={{
              scrollbarWidth: "none",
              borderBottomLeftRadius: 33,
              borderBottomRightRadius: 33,
            }}
          >
            <Timeline position="right" sx={{ p: 0 }}>
              {isBorrower && <OfferInformation />}
              {isBorrower && <NPEAnnouncement />}
              {isBorrower && <InitialOfferVerification />}
              <IdVerification />
              <CreditVerification />
              {isBorrower && <HomeValueVerification />}
              <IncomeVerification />
              {isBorrower && <AnnuncementCoborrowerPending />}
              {isBorrower && <AnnuncementCreateNewOfferPending />}
              {isBorrower && <FinalOfferVerification />}
              <DemographicDataVerification />
              <InitialDisclosuresVerification />
              {isBorrower && <TitleVerification />}
              <ScheduleClosingVerification />
              <ClosingDisclosuresVerification />
              {isBorrower && <FundingVerification />}
            </Timeline>
          </Box>
        </Box>
        <QuestionsBox />
      </Container>
    </Fragment>
  );
};

export default CTracker;
